import angular from 'angular';
import internalSystemOptionsDirective from './internal-system-options.directive';
import internalSystemOption from './internalSystemOption';


export default angular.module('app.components.advisory.enterpriseModeling.internalSystemOptions', [
  internalSystemOption
])
  .directive('emInternalSystemOptions', internalSystemOptionsDirective)
  .controller('InternalSystemOptionsController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.enterpriseModeling.internalSystemOptions created');
